import type { ReactNode } from "react";

type Props = {
    active: boolean;
    children: ReactNode;
}

export default function TabPane(props: Props) {
    return (
        <div
            className={`mt-3 tab-pane fade ${props.active ? "show active" : ""}`}
            role="tabpanel"
            tabIndex={0}
        >
            <div className="d-flex flex-column gap-3">
                {props.children}
            </div>
        </div>
    );
}
